// extracted by mini-css-extract-plugin
module.exports = {"rippleBtn":"_XNbC"};